/* eslint-disable no-nested-ternary */
export default {
  buttonStyles: {
    // eslint-disable-next-line no-unused-vars
    customButtonStyles: (vm) => {
      return {
        'border-radius': vm.card ? '8px' : '14px',
        background:
          // eslint-disable-next-line no-nested-ternary
          !vm.disabled && !vm.selected && !vm.hover
            ? 'var(--v-secondary-lighten2)!important'
            : vm.disabled
            ? 'gray'
            : 'var(--v-secondary-lighten1)!important',
        color: vm.disabled ? '' : 'white',
        border: '0px',
        'border-color': 'var(--v-primary-lighten1)  !important',
      };
    },
    customButtonClasses: (vm) => {
      return {
        'secondary white--text font-weight-bold': vm.variant && !vm.disabled,
      };
    },
  },
  theme: {
    anchor: '#1e88e5' /* blue -- info */,
    accent: {
      base: '#f0c700' /* blue -- info */,
      darken1: '#979797' /* grey */,
    },
    info: {
      base: '#1e88e5' /* blue */,
      darken1: '#7460ee' /* indigo */,
      darken2: '#563dea' /* dark indigo */,
      darken3: '#6f42c1' /* purple */,
    },
    primary: {
      base: '#6D98BA' /* light blue */,

      darken1: '#34566F' /* white */,
    },
    secondary: {
      base: '#52525b' /* gray slate */,
      lighten1: '#52525b' /* lighter blue */,
      lighten2: '#52525b',
      darken1: '#52525b',
    },
    error: {
      base: '#fc4b6c' /* red */,
      lighten1: '#e83e8c' /* pink */,
    },
    success: {
      base: '#10b981' /* sea green */,
      darken1: '#20c997' /* true green */,
    },
    warning: {
      base: '#ffb22b' /* yellow */,
      darken1: '#fd7e14' /* orange */,
      darken2: '#ef5350' /* dark orange */,
    },
    background: '#f8fafc' /* truforme brown/tan */,
    customGlobalStyles: {
      '-webkit-font-smoothing': 'antialiased',
      'font-family': "'Poppins', sans-serif!important",
    },
    customStyleSheet: 'truforme',
  },
};
